import { EmptyMarketplaceProvider } from './empty-marketplace-provider';
export class MarketplaceCreator {
    /**
     * Set the customMarketplaceProvider as the singleton marketplaceProvider.
     * @param {MarketplaceProvider} customMarketplaceProvider - User specified marketplace marketplaceProvider
     */
    static setProvider(customMarketplaceProvider) {
        MarketplaceCreator.marketplaceProvider = customMarketplaceProvider;
    }
    /**
     * Create singleton Marketplace marketplaceProvider which creates marketplace configuration.
     * Return the singleton marketplaceProvider if it exists.
     * Otherwise, set an EmptyMarketplaceProvider object as singleton marketplaceProvider and return it.
     * @return {MarketplaceProvider} the singleton MarketplaceProvider marketplaceProvider
     */
    static provider() {
        if (!MarketplaceCreator.marketplaceProvider) {
            MarketplaceCreator.marketplaceProvider = new EmptyMarketplaceProvider();
        }
        return MarketplaceCreator.marketplaceProvider;
    }
}
MarketplaceCreator.marketplaceProvider = undefined;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFya2V0cGxhY2UtY3JlYXRvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9tYXJrZXRwbGFjZS1jcmVhdG9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSx3QkFBd0IsRUFBRSxNQUFNLDhCQUE4QixDQUFDO0FBR3hFLE1BQU0sT0FBTyxrQkFBa0I7SUFDM0I7OztPQUdHO0lBQ0ksTUFBTSxDQUFDLFdBQVcsQ0FBQyx5QkFBOEM7UUFDcEUsa0JBQWtCLENBQUMsbUJBQW1CLEdBQUcseUJBQXlCLENBQUM7SUFDdkUsQ0FBQztJQUVEOzs7OztPQUtHO0lBQ0ksTUFBTSxDQUFDLFFBQVE7UUFDbEIsSUFBSSxDQUFDLGtCQUFrQixDQUFDLG1CQUFtQixFQUFFO1lBQ3pDLGtCQUFrQixDQUFDLG1CQUFtQixHQUFHLElBQUksd0JBQXdCLEVBQUUsQ0FBQztTQUMzRTtRQUNELE9BQU8sa0JBQWtCLENBQUMsbUJBQW1CLENBQUM7SUFDbEQsQ0FBQzs7QUFFYyxzQ0FBbUIsR0FBb0MsU0FBUyxDQUFDIn0=